import Button from "../../../../form/Button";
import React from "react";
import {isEmpty} from "../../../../../utils/other";

export default (propsTop) => {
    const {props, state, parent} = propsTop;
    const {hidden, labels, pool, operationitems, actionButtons} = props;
    return <Button
                   disabled={isEmpty(props.values.saved) || props.isLoading}
                   color="danger"
                   className="pull-left"
                   onClick={ async () => {
                       await props.deleteForm();
                       parent.componentList.refresh();
                   }}>
        Törlés
    </Button>
}